'use client';

import { getInitials } from '@bells/core/lib/initals';
import { cn } from '@bells/core/lib/utils';
import { blogReadTime } from '@bells/i18n';
import type { Locale } from '@bells/i18n/runtime';
import { Calendar, Clock } from 'lucide-react';
import { Avatar, AvatarFallback } from '../../../components/avatar';
import { CalendarFormat } from '../../../components/date-formatter';
export const BlogDescription = ({
  lng,
  userName,
  createdAt,
  readingTime,
}: {
  lng?: Locale;
  userName?: string;
  createdAt?: string | null;
  readingTime?: number;
}) => {
  return (
    <div className='flex items-center justify-between'>
      <div className='flex flex-wrap items-center gap-4 font-sans text-base text-muted-foreground'>
        <span className='inline-flex items-center gap-1'>
          <Avatar className='mr-1 h-8 w-8'>
            <AvatarFallback
              className={cn(
                'bg-primary text-[12px] uppercase text-primary-foreground'
              )}
            >
              {getInitials(userName)}
            </AvatarFallback>
          </Avatar>
          {userName}
        </span>

        <span className='inline-flex items-center'>
          <Clock className='mr-1 inline-block h-4 w-4'></Clock>
          {blogReadTime({ minutes: readingTime ?? 0 }, { locale: lng })}
        </span>

        <span className='inline-flex items-center'>
          <Calendar className='mr-1 inline-block h-4 w-4'></Calendar>
          <CalendarFormat date={createdAt} locale={lng}></CalendarFormat>
        </span>
      </div>
    </div>
  );
};
